<p-toolbar>
  <div class="p-toolbar-group-start">
    <p-button label="Sync"
              icon="pi pi-sync"
              class="p-button-primary mr-2"
              (onClick)="onSyncClick()"
              [loading]="isSyncing">
    </p-button>
  </div>
</p-toolbar>

<p-table #dt
         dataKey="id"         
         [value]="(data$ | async)!"
         [loading]="(isLoading$ | async)!"
         [totalRecords]="(dataCount$ | async)!"
         [lazy]="true"
         [rows]="10"
         [showCurrentPageReport]="true"
         [rowsPerPageOptions]="[10, 25, 50]"
         [paginator]="true"
         [globalFilterFields]="['carrier.friendly_name']"
         [filterDelay]="250"
         [breakpoint]="'960px'"
         [rowHover]="true"
         (onLazyLoad)="onLazyLoad($event)"
         currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
         sortField="carrier.friendly_name"
         sortMode="single"
         responsiveLayout="stack">
  <ng-template pTemplate="caption">
    <div class="flex">
      Carriers / Services
      <span class="p-input-icon-left ml-auto">
        <i class="pi pi-search"></i>
        <input pInputText type="text" placeholder="Search keyword" (input)="applyFilterGlobal($event)" />
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th style="min-width:15rem" pSortableColumn="carrier.friendly_name">
        <div class="flex align-items-center">
          Name
          <p-sortIcon field="carrier.friendly_name"></p-sortIcon>
          <p-columnFilter type="text" field="carrier.friendly_name" display="menu"></p-columnFilter>
        </div>
      </th>
      <th style="min-width:15rem">
        <div class="flex align-items-center">
          Has Active Services
        </div>
      </th>
      <th style="width: 8rem"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-carrier>
    <tr [ngClass]="{'deleted-record': carrier.deleteDate}">
      <td>
        <span class="p-column-title"><strong>Name</strong></span>
        {{carrier.friendly_name}}
      </td>
      <td>
        <span class="p-column-title"><strong>Has Active Services</strong></span>
        {{carrier.hasActiveServices}}
      </td>
      <td style="text-align: center">
        <button pButton
                pRipple
                icon="pi pi-pencil"
                class="p-button-rounded p-button-primary mr-2"
                (click)="openEntity(carrier)"
                pTooltip="Edit"
                tooltipPosition="left">
        </button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7">No carriers found.</td>
    </tr>
  </ng-template>
</p-table>
